import React, { useCallback, useRef } from 'react';
import { useUpdateEffect } from 'react-use';

import { stopEventPropagation } from '@lyearn/core/utils/events';
import { BaseMenuItem } from '@lyearn/ui';

import { classes } from '../../styles';
import { MentionsListItemProps } from '../../types';

const MentionsListItem: React.FC<React.PropsWithChildren<MentionsListItemProps>> = (props) => {
  const { index, isSelected, onClick, children } = props;

  const ref = useRef<HTMLLIElement>(null);

  const _onClick: React.MouseEventHandler<HTMLLIElement> = useCallback(
    (event) => {
      stopEventPropagation(event);
      onClick?.();
    },
    [onClick],
  );

  useUpdateEffect(() => {
    if (!isSelected && ref) {
      ref.current?.blur();
    }
  }, [isSelected]);

  return (
    <BaseMenuItem
      ref={ref}
      className={classes.listItem}
      data-index={index}
      selected={isSelected}
      onClick={_onClick}>
      {children}
    </BaseMenuItem>
  );
};

export default MentionsListItem;
